/**
 * @generated SignedSource<<736da6c0571dbdf8e3e1ac33f63eba7f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateCustomFieldValueInput = {
  id?: string | null;
  entityId?: string | null;
  entityType?: string | null;
  key?: string | null;
  value?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateCustomFieldValueMutation$variables = {
  input: UpdateCustomFieldValueInput;
};
export type updateCustomFieldValueMutation$data = {
  readonly updateCustomFieldValue: {
    readonly customFieldValue: {
      readonly node: {
        readonly id: string;
        readonly key: string;
        readonly displayName: string;
        readonly value: string | null;
        readonly displayValue: string | null;
      } | null;
    } | null;
  } | null;
};
export type updateCustomFieldValueMutation = {
  variables: updateCustomFieldValueMutation$variables;
  response: updateCustomFieldValueMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayValue",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateCustomFieldValueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCustomFieldValuePayload",
        "kind": "LinkedField",
        "name": "updateCustomFieldValue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomFieldValueV2TypeEdge",
            "kind": "LinkedField",
            "name": "customFieldValue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateCustomFieldValueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCustomFieldValuePayload",
        "kind": "LinkedField",
        "name": "updateCustomFieldValue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomFieldValueV2TypeEdge",
            "kind": "LinkedField",
            "name": "customFieldValue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "15e1ca3453fbcd69c4696ee45c37f980",
    "id": null,
    "metadata": {},
    "name": "updateCustomFieldValueMutation",
    "operationKind": "mutation",
    "text": "mutation updateCustomFieldValueMutation(\n  $input: UpdateCustomFieldValueInput!\n) {\n  updateCustomFieldValue(input: $input) {\n    customFieldValue {\n      node {\n        __typename\n        id\n        key\n        displayName\n        value\n        displayValue\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0164dc9b7e8a27408fbc5eaf6a075f4c";

export default node;
